/* eslint-disable no-unused-vars */
import _ from 'lodash';

import { h, render } from 'preact';

import FindYourDistricts from '../components/FindYourDistricts';
import Ballotdata from '../../../data/data.json';
import Contextdata from '../../../data/text.json';

// main code for feature graphics

function onSelect(data) {}

render(
  <FindYourDistricts
    onSelect={onSelect}
    contests={Ballotdata}
    notes={Contextdata.notes}
  />,
  document.getElementById('lookup-select')
);

// // main code for feature graphics
// // a reference to the default graphic container, change if needed
// const container = d3.select('.results-container');

// // a helper function to clear the container of its contents
// const clearContainer = () => container.html('');

// // a helper function to grab the container's width
// const getFrameWidth = () => container.node().offsetWidth;

// import data by getting the window variable, OR by importing the filepath
// let data = window.DATA;
// import data from '../../../data/data.json';
// import data from 'Data/data.json';

let input = document.querySelector('#select-office');

let MOBILE_THRESHOLD = 544;

let containerWidth = document.getElementsByClassName('results-container')
  .offsetWidth;

let isMobile = containerWidth <= MOBILE_THRESHOLD ? true : false;

var selectedItem = sessionStorage.getItem('SelectedItem');
if (selectedItem) {
  document.getElementById('select-office').value = selectedItem;
}

input.addEventListener('change', function() {
  const elem = document.getElementById(this.value);
  sessionStorage.setItem('SelectedItem', this.value);

  scrollIt(elem);
});

function scrollIt(element) {
  const y =
    element.getBoundingClientRect().top +
    window.pageYOffset -
    (isMobile ? 115 : 75);

  window.scrollTo({
    behavior: 'smooth',
    left: 0,
    top: y,
  });
}

// Added a function to tell when the sticky bar is stuck so that we can hide the "See who's running for:" for mobile.

const observer = new IntersectionObserver(
  ([e]) => e.target.toggleAttribute('stuck', e.intersectionRatio < 1),
  { threshold: [1] }
);

observer.observe(document.querySelector('#sticky-bar'));

// function resize() {
//   // code executed on window resize
//   // pass the recalculated frameWidth to parts of your chart (like an axis) that change with resize!
//   clearContainer();
//   const frameWidth = getFrameWidth();
// }

// // call resize on load
// resize();
// window.addEventListener('resize', _.debounce(resize, 200));
